// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__27sUJ","hiddenElements":"Header_hiddenElements__V-3vW","search":"Header_search__3dNOs","dark":"Header_dark__2y5wv","wrapper":"Header_wrapper__ZccyR"};